import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Copy } from "@air/next-icons";
import { useCopyToClipboard } from "__barrel_optimize__?names=useCopyToClipboard!=!react-use";
export const CustomFieldFormAPIInformationCopyValue = (param)=>{
    let { id } = param;
    const [state, copyToClipboard] = useCopyToClipboard();
    return /*#__PURE__*/ _jsxs("div", {
        className: "group/custom-field-api-value inline-flex gap-1",
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: "select-all text-12 text-grey-9",
                onClick: ()=>copyToClipboard(id),
                type: "button",
                children: id
            }),
            !!state.value ? /*#__PURE__*/ _jsx(Check, {
                className: "size-4 text-blue-9"
            }) : /*#__PURE__*/ _jsx(Copy, {
                className: "hidden size-4 text-grey-9 group-hover/custom-field-api-value:block"
            })
        ]
    });
};
